import { pgTable, uuid, text, timestamp, index } from "drizzle-orm/pg-core";

export const visits = pgTable(
  "visits",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    sessionId: uuid("session_id").notNull(),
    storefrontSource: text("storefront_source").notNull().default("lv"),
    path: text("path").notNull(),
    referrer: text("referrer"),
    countryCode: text("country_code"),
    city: text("city"),
    deviceType: text("device_type"),
    browser: text("browser"),
    os: text("os"),
    userAgentHash: text("user_agent_hash"),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    sessionCreatedIdx: index("idx_visits_session_created").on(t.sessionId, t.createdAt),
    createdSourceIdx: index("idx_visits_created_source").on(t.createdAt, t.storefrontSource),
  }),
);

export type Visit = typeof visits.$inferSelect;
export type NewVisit = typeof visits.$inferInsert;
